import { Box, IconButton, Modal, Typography, useMediaQuery, useTheme } from "@mui/material";
import { Cadet } from "../../shared/types/scoreboard.types";
import { Close } from "@mui/icons-material";
import { handleDetailKeyToString } from "../../utils/scoreboardUtils";
import React from "react";

interface MobileModalComponentProps {
  selectedCadet: Cadet | null;
  onCloseDrawer: () => void;
}

export const MobileModalComponent: React.FC<MobileModalComponentProps> = ({ selectedCadet, onCloseDrawer }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleCloseDrawer = () => {
    onCloseDrawer();
  };

  return (
    <>
      {isMobile && (
        <Modal
          open={Boolean(selectedCadet)}
          onClose={handleCloseDrawer}
          sx={{
            // display: "flex",
            alignItems: "center",
            justifyContent: "center",
            p: 2,
          }}
        >
          <Box
            sx={{
              width: "100%",
              maxWidth: "95vw",
              maxHeight: "90vh",
              bgcolor: "background.paper",
              borderRadius: "8px",
              boxShadow: 24,
              p: 2,
              overflow: "auto",
            }}
          >
            {selectedCadet && (
              <>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 2,
                    pb: 1,
                    borderBottom: `1px solid ${theme.palette.divider}`,
                  }}
                >
                  <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                    {selectedCadet.primaryCadet}
                  </Typography>
                  <IconButton onClick={handleCloseDrawer} size="small">
                    <Close />
                  </IconButton>
                </Box>

                {/* Simple Key Metrics */}
                <Box sx={{ mb: 3 }}>
                  {selectedCadet.isDisqualified && (
                    <Box
                      sx={{
                        backgroundColor: "#ffabab",
                        padding: 1,
                        borderRadius: 1,
                        mb: 2,
                      }}
                    >
                      <Typography variant="body2" color="text.secondary">
                        This cadet is disqualified as they have missed 2 classes or have less than or equal to 0 total points.
                      </Typography>
                    </Box>
                  )}
                  {!selectedCadet.isDisqualified && (
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                      Rank: {selectedCadet.rank}
                    </Typography>
                  )}
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                    SMD: {selectedCadet.smd}
                  </Typography>
                  {selectedCadet.spousePartner !== "" && (
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                      Spouse/Partner: {selectedCadet.spousePartner}
                    </Typography>
                  )}
                  <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                    Total: {selectedCadet.total.toFixed(2)}
                  </Typography>
                </Box>

                {/* Simple Cycle Data */}
                <Box sx={{ mt: 2 }}>
                  {["c1", "c2", "c3", "c4", "c5"].map((cycle) => (
                    <Box key={cycle} sx={{ mb: 3 }}>
                      <Typography variant="subtitle2" sx={{ fontWeight: "bold", mb: 1 }}>
                        {cycle.replace("c", "Class ")} Details
                      </Typography>

                      <Box
                        sx={{
                          display: "grid",
                          gridTemplateColumns: "repeat(2, 1fr)",
                          gap: 1,
                        }}
                      >
                        {selectedCadet &&
                          Object.entries(selectedCadet[cycle as keyof Cadet])
                            .filter(
                              ([key]) =>
                                key !== "total" &&
                                ((cycle !== "c3" &&cycle !== "c4" && cycle !== "c5" && key !== "callout" && key !== "calloutNotes") ||
                                  cycle === "c3" ||
                                  cycle === "c4" ||
                                  cycle === "c5")
                            )
                            .map(([key, value]) => (
                              <Box key={key} sx={{ mb: 1 }}>
                                <Typography variant="caption" color="text.secondary">
                                  {handleDetailKeyToString(key, cycle)}:
                                </Typography>
                                <Typography variant="body2">{typeof value === "number" ? value.toFixed(2) : value || "-"}</Typography>
                              </Box>
                            ))}
                      </Box>
                    </Box>
                  ))}
                </Box>
              </>
            )}
          </Box>
        </Modal>
      )}
    </>
  );
};
